import React from 'react';
import { SkeletonProps } from 'react-loading-skeleton';

import Skeleton from './Skeleton';

const DarkSkeleton = (props: SkeletonProps) => {
    return <Skeleton className="sgw-skeleton__dark" {...props} />;
};

export default DarkSkeleton;
